import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import withPulse from 'components/Decorators/withPulse';
import AuthWrapper from 'providers/AuthWrapper';
import Layout from 'components/Layout';
import { SingleTemplate } from 'templates/components';
import { collectSingleTemplateMetaData, getDisplayNameFromUrl } from 'templates/utils';
import useDevice from 'hooks/useDeviceType';
import GlobalProviders from 'providers/GlobalProviders';
import JSONLinkedData from 'components/JSONLinkedData';
import { SchemaType } from 'components/JSONLinkedData/types';
import useSingleTemplatesDataStore from 'templates/stores/singleTemplateDataStore';

const SingleTemplatePage = () => {
  const { templateId } = useParams();
  const { isMobile } = useDevice();

  const { templateData } = useSingleTemplatesDataStore(state => ({
    templateData: state.singleTemplateData,
  }));
  // Getting the display name from the URL to prevent unnecessary re-renders
  const displayName = useMemo(() => getDisplayNameFromUrl(templateId), [templateId]);
  const breadcrumbSchema = useMemo(() => {
    const subtypeName = templateData?.subtypes?.[0];
    return [
      {
        position: 1,
        anchor: 'Home',
        link: '/',
      },
      {
        position: 2,
        anchor: 'Templates',
        link: '/templates/',
      },
      {
        position: 3,
        anchor: subtypeName || displayName,
        link: `/template/${templateId}`,
      },
    ];
  }, [displayName, templateId, templateData]);

  const metaCollection = useMemo(() => {
    return collectSingleTemplateMetaData(displayName);
  }, [displayName]);

  return (
    <GlobalProviders isLocalized={false} dropdownLanguagesList={{}} slug="" dataFetched>
      <AuthWrapper>
        <Layout
          isMobile={isMobile}
          title={displayName}
          ogDescription={metaCollection.description}
          metaDescription={metaCollection.description}
          canonicalUrl={metaCollection.canonicalURL}
          ogTitle={metaCollection.ogTitle}
          noIndex={metaCollection.noIndex}
          isLocalized={false}
          hasDefaultBreadcrumb={false}
          footerRelevantLinkEnabled={false}
        >
          {breadcrumbSchema && (
            <JSONLinkedData data={breadcrumbSchema} type={SchemaType.ItemList} />
          )}
          <SingleTemplate />
        </Layout>
      </AuthWrapper>
    </GlobalProviders>
  );
};

export default withPulse(SingleTemplatePage);
